import {
  Button,
  HStack,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { ViajaYaIcon } from "../../icons/ViajaYaIcon";
import { AppleIcon } from "../../icons/AppleIcon";
import { WspIcon } from "../../icons/WspIcon";
import { PlayStoreIcon } from "../../icons/PlayStoreIcon";
import { storeLinks } from "../../utils/constants";
import { RightArrowIcon } from "../../icons/RightArrowIcon";
import { WspLogoIcon } from "../../icons/WsplogoIcon";
import { Link } from "react-router-dom";
export const Download = () => {
  return (
    <VStack
      bgColor="primary.900"
      rounded="xl"
      w="80%"
      py={[10, 10, 20]}
      pl={[6, 6, 20]}
      pr={[6, 6, 28]}
      justifyContent={["flex-start", "flex-start", "space-between"]}
      alignItems={["flex-start", "flex-start", "center"]}
      position="relative"
      gap={2}
      id="download"
    >
      <ViajaYaIcon h={[20, 20, 10]} w={[20, 20, 10]} />
      <Text
        fontSize={["xx-large", "xx-large", "x-large"]}
        fontWeight="semibold"
        color="#fff"
      >
        ¿Estás listo para viajar?
      </Text>
      <HStack
        display={["none", "none", "flex"]}
        w={"70%"}
        mt="20px"
        justifyContent="space-between"
        alignItems="center"
      >
        <Button
          px="15px"
          pr="30px"
          bgColor="#000"
          _hover={{ bgColor: "#000" }}
          py={8}
          gap={4}
          color="#fff"
          onClick={() => window.open(storeLinks.apple.client)}
        >
          <AppleIcon h={8} w={8} color="#fff" />
          <VStack justifyContent="flex-start" alignItems="flex-start" gap={0}>
            <Text fontSize="14px" color="#fff">
              Descarga en iphone
            </Text>
            <Text fontSize="24px" fontWeight="semibold" color="#fff">
              App store
            </Text>
          </VStack>
        </Button>
        <Button
          px="15px"
          pr="30px"
          bgColor="#25D366"
          _hover={{ bgColor: "#25D366" }}
          py={8}
          gap={4}
          color="#fff"
          onClick={() => window.open(storeLinks.wsp)}
        >
          <WspIcon h={40} w={40} color="#fff" />
        </Button>
        <Button
          px="15px"
          pr="30px"
          bgColor="#000"
          _hover={{ bgColor: "#000" }}
          py={8}
          gap={4}
          onClick={() => window.open(storeLinks.android.client)}
        >
          <PlayStoreIcon h={8} w={8} color="#fff" />
          <VStack justifyContent="flex-start" alignItems="flex-start" gap={0}>
            <Text fontSize="14px" color="#fff">
              Descarga en android
            </Text>
            <Text fontSize="24px" fontWeight="semibold" color="#fff">
              Play store
            </Text>
          </VStack>
        </Button>
      </HStack>
      <Stack
        display={["none", "none", "flex"]}
        w="full"
        justifyContent="center"
        alignItems="center"
        gap="40px"
      >
        <HStack
          mt={10}
          w="70%"
          rounded="xl"
          p={6}
          justifyContent="space-between"
          alignItems="center"
          borderWidth="1px"
          borderColor="primary.600"
          gap={6}
        >
          {/* <QrIcon h={20} w={20} rounded="md" /> */}
          <Image src="/QrCliente.png" alt="qr" w={20} h={20} rounded="md" />
          <Text fontSize="18px" fontWeight="" color="#fff">
            Escanea el código para descargar nuestra app para{" "}
            <Text fontWeight="extrabold" display="inline" color="#fff">
              clientes
            </Text>
            .
          </Text>
        </HStack>
        <HStack
          mt={10}
          w="70%"
          rounded="xl"
          p={6}
          justifyContent="space-between"
          alignItems="center"
          borderWidth="1px"
          borderColor="primary.600"
          gap={6}
        >
          <Image src="/QrDriver.png" alt="qr" w={20} h={20} rounded="md" />
          <Text fontSize="18px" color="#fff">
            Escanea el código para descargar nuestra app para{" "}
            <Text fontWeight="extrabold" display="inline" color="#fff">
              conductores
            </Text>
            .
          </Text>
        </HStack>
      </Stack>
      <VStack mt={4} p={0} gap={4} display={["flex", "flex", "none"]}>
        <Link to={"/download-client"}>
          <HStack
            p={4}
            borderWidth="1px"
            borderColor="primary.600"
            gap={"10px"}
            rounded="xl"
          >
            <Text fontSize="medium" color="#fff">
              Descarga nuestra app para <strong>clientes</strong>.
            </Text>
            <RightArrowIcon
              h={10}
              w={10}
              color="#fff"
              bgColor={"primary.700"}
              rounded="lg"
            />
          </HStack>
        </Link>
        <Link to={"/download-driver"}>
          <HStack
            p={4}
            borderWidth="1px"
            borderColor="primary.600"
            gap={"10px"}
            rounded="xl"
          >
            <Text fontSize="medium" color="#fff">
              Descarga nuestra app para <strong>conductores</strong>.
            </Text>
            <RightArrowIcon
              h={10}
              w={10}
              color="#fff"
              bgColor={"primary.700"}
              rounded="lg"
            />
          </HStack>
        </Link>
        <Link to={storeLinks.wsp}>
          <HStack
            p={4}
            borderWidth="1px"
            borderColor="primary.600"
            rounded="xl"
            gap="10px"
          >
            <WspLogoIcon
              h={10}
              w={10}
              color="#fff"
              bgColor="#25D366"
              rounded="lg"
              p={2.5}
            />
            <Text fontSize="medium" color="#fff">
              O ingresa a nuestro WhatsApp y pide un <strong>viaje</strong>.
            </Text>
            <RightArrowIcon
              h={10}
              w={10}
              color="#fff"
              bgColor={"primary.700"}
              rounded="lg"
            />
          </HStack>
        </Link>
      </VStack>
    </VStack>
  );
};
